<template>
    <div class="public-view-bg">
        <h1 class="public-view-header">Planowane wyłączenia</h1>
        <div class="public-view-table">
            <h2 class="public-view-info">Sprawdź planowane wyłączenia w swojej okolicy</h2>
            <p class="public-view-info public-view-info__red">
                Planowane wyłączenie może być odwołane bez uprzedzenia
            </p>
            <PlannedOutageSearchCriteriaPublic ref="PlannedOutageSearchCriteria" v-model="searchCriteria"
                                               @update:modelValue="search" :is-public-view="true"/>
            <PlannedOutageTablePublic ref="plannedOutageTable" :search-criteria="searchCriteria"/>
        </div>
    </div>
</template>

<script>
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import PlannedOutageSearchCriteriaPublic from "./components/PlannedOutageSearchCriteriaPublic";
    import PlannedOutageTablePublic from "./components/PlannedOutageTablePublic";

    export default {
        components: {
            PlannedOutageSearchCriteriaPublic,
            PlannedOutageTablePublic,
        },
        data() {
            return {
                searchCriteria: this.getClearSearchCriteria(),
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },
        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$refs.plannedOutageTable.search();
            },

            createdBy() {
                this.$router.push({name: "plannedOutageCreate"});
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    area: null,
                    outageStart: null,
                    outageEnd: null,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "@/assets/theme/variable.less";
    .public-view-bg {
        background-image: url("../../assets/plannedBG.jpg");
        background-attachment: fixed;
        background-size: cover;
        padding-top: 3.75em;
    }
    .with-tab-menu-body {
        padding-top: 0;
    }
    .public-view-header {
        color: white;
        margin-top: 40px;
        margin-bottom: 40px;
        margin-left: 10%;
        font-size: 6.25rem;
        text-align: left;
        @media screen and (max-width: 600px) {
            margin-left: 10px;
        }
        @media screen and (max-width: 550px) {
            font-size: 4.75rem;
        }
        @media screen and (max-width: 450px) {
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 2.25rem;
        }
    }
    .public-view-info {
        color: #00568f;
        font-size: 2rem;
        text-align: left;
        margin-left: 4%;
        font-weight: bold;
        @media screen and (max-width: 550px) {
            font-size: 1.75rem;
        }
        @media screen and (max-width: 450px) {
            font-size: 1.125rem;
        }
        &__red {
            color: @tint-bordeaux-00;
            font-size: 1.375rem;
            @media screen and (max-width: 550px) {
                font-size: 1.125rem;
            }
            @media screen and (max-width: 450px) {
                font-size: 1rem;
            }
        }
    }
    .public-view-table {
        background-color: white;
        width: 80%;
        margin-left: 10%;
        margin-right: 10%;
        //margin-bottom: 50px;
        padding-top: 10px;
        min-height: calc(100vh - 306px);
        @media screen and (max-width: 600px) {
            margin: 0 10px;
            width: auto;
        }
    }
    html[data-font-size='2'] {
        .public-view-header {
            margin-left: 5%;
        }
        .public-view-table {
            width: 90%;
            margin-left: 5%;
            margin-right: 5%;
        }
    }
</style>
